export default "__VITE_ASSET__77475408__"